import { Icons } from "assets";
import classNames from "classnames";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "shared/modal/confirmation";
import { resetAuthReducer } from "shared/redux/reducers/authSlice";
import { toastMessage } from "../toast";
import NavItem from "./navItem";
import styles from "./style.module.scss";
import { routeConstant } from "shared/routes/routeConstant";
import { Link } from "react-router-dom";

interface Props {
  sidebarArr: SideBarItemsType[];
}

function DashboardSidebar({ sidebarArr }: Props) {
  const { auth } = useSelector((state: any) => state.root);

  const dispatch = useDispatch();
  const [openConfirmationModal, setOpenConfirmationModal] =
    useState<boolean>(false);

  const handleOpenConfirmationModal = () => {
    setOpenConfirmationModal(true);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };

  const handleLogout = () => {
    dispatch(resetAuthReducer());
    toastMessage("success", "Logged out successfully");
  };

  return (
    <div className={classNames(styles.sidebarWrapper)}>
      <div className="text-center w-full flex flex-col items-start bg-[#18212b]">
        <div className={classNames(styles.logoTopContainerFull, "w-full px-2")}>
          <div
            className={classNames(
              "flex items-center w-full",
              styles.logoContainer
            )}
          >
            <Link to={routeConstant.dashboard.path}>
              <Icons.Logo />
            </Link>
          </div>
        </div>
        <div
          className={classNames(
            "flex items-center gap-2",
            styles.userInfoContainer
          )}
        >
          <div className={classNames(styles.avtInitials)}>
            <label>
              {auth?.user?.fullname?.split(" ")?.[0]?.[0]}
              {auth?.user?.fullname?.split(" ")?.[1]?.[0]}
            </label>
          </div>
          <div className={classNames("flex flex-col items-start")}>
            <p>{auth?.user?.fullname}</p>
            <span>{auth?.user?.email}</span>
          </div>
        </div>
        <div
          className={classNames(
            "flex flex-col justify-between h-full mt-3 gap-3"
          )}
        >
          <div
            className={classNames(styles.sideNavFull, "flex flex-col gap-1")}
          >
            {sidebarArr?.map((item, inx) => {
              return (
                <div className="flex flex-col items-start gap-1" key={inx}>
                  <label className={classNames(styles.navTitle)}>
                    {item?.title}
                  </label>

                  <div className="w-full flex flex-col gap-0">
                    {item?.paths?.map(
                      (s: SideBarItemPathType, s_inx: number) => {
                        const props = {
                          ...s,
                        };
                        return <NavItem {...props} key={s_inx} />;
                      }
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={classNames(
              styles.navItemContainer,
              styles.logoutContainer
            )}
            onClick={handleOpenConfirmationModal}
          >
            <Icons.Logout className={classNames(styles.logoutIcon)} />
            <label
              className={classNames(
                styles.heading,
                styles.logout,
                "cursor-pointer"
              )}
            >
              Logout
            </label>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={openConfirmationModal}
        handleClose={handleCloseConfirmationModal}
        subtitle="Are you sure you want to logout?"
        actionButtonText="Yes, Logout"
        handleSubmit={handleLogout}
      />
    </div>
  );
}

export default DashboardSidebar;
